export interface ElectricalWorkItem {
  Item: string;
  Type: string;
  check: boolean;
  Quantity: number;
}

export interface GetAllFee {
  'Certification Cost': number;
  totalFee: number;
  summary: any[];
}

export interface ElectricalData {
  EstimatedCostOfElectricWork: number;
  WorkItems: ElectricalWorkItem[];
  getAllFee: GetAllFee;
}

export const electricalData: ElectricalData = {
  EstimatedCostOfElectricWork: 0,
  WorkItems: [
    {
      Item: 'Lighting Fixture',
      Type: 'Receptacles And Fixtures',
      check: false,
      Quantity: 0,
    },
    {
      Item: 'Receptacles',
      Type: 'Receptacles And Fixtures',
      check: false,
      Quantity: 0,
    },
    {
      Item: 'Switches',
      Type: 'Receptacles And Fixtures',
      check: false,
      Quantity: 0,
    },
    {
      Item: 'Detectors',
      Type: 'Receptacles And Fixtures',
      check: false,
      Quantity: 0,
    },
    {
      Item: 'Light Poles',
      Type: 'Receptacles And Fixtures',
      check: false,
      Quantity: 0,
    },
    {
      Item: 'Service panels, entrances',
      Type: 'Service Panels And Entrances',
      check: false,
      Quantity: 0,
    },
    {
      Item: 'Motors - Fract. HP',
      Type: 'Motors And Devices',
      check: false,
      Quantity: 0,
    },
    {
      Item: 'Emergency & Exit Lights',
      Type: 'Receptacles And Fixtures',
      check: false,
      Quantity: 0,
    },
    {
      Item: 'Communications Points',
      Type: 'Receptacles And Fixtures',
      check: false,
      Quantity: 0,
    },
    {
      Item: 'Alarm Devices/F.A.C Panel',
      Type: 'Receptacles And Fixtures',
      check: false,
      Quantity: 0,
    },
    {
      Item: 'Pool Permit/with UW Lights',
      Type: 'Receptacles And Fixtures',
      check: false,
      Quantity: 0,
    },
    {
      Item: 'Storable Pool/Spa/Hot Tub',
      Type: 'Flat Fees',
      check: false,
      Quantity: 0,
    },
  ],
  getAllFee: {
    'Certification Cost': 0,
    totalFee: 0,
    summary: [],
  },
};
